import styles from './Configurator.module.css'

interface FrameSelectorProps {
  selected: 'black' | 'transparent'
  onSelect: (frame: 'black' | 'transparent') => void
}

export function FrameSelector({ selected, onSelect }: FrameSelectorProps) {
  return (
    <div className={styles.frameSelectorContainer}>
      <span className={styles.swatchesLabel}>Marco Base</span>
      <div className={styles.frameOptions}>
        <button
          className={`${styles.frameOption} ${selected === 'black' ? styles.frameOptionSelected : ''}`}
          onClick={() => onSelect('black')}
          aria-pressed={selected === 'black'}
        >
          Negro
        </button>
        <button
          className={`${styles.frameOption} ${selected === 'transparent' ? styles.frameOptionSelected : ''}`}
          onClick={() => onSelect('transparent')}
          aria-pressed={selected === 'transparent'}
        >
          Transparente
        </button>
      </div>
    </div>
  )
}
